import React, { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import Loading from "../Loader/Loading";
import "./ticketassign.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function Ticketassign({
  TicketNumber,
  assignedTo,
  fetchTickets,
  selectedticketno,
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [supportData, setSupportData] = useState([]);
  const userDetails = JSON.parse(localStorage.getItem("userdetails"));

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(5);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = supportData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(supportData.length / itemsPerPage);

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage((prev) => prev + 1);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage((prev) => prev - 1);
  };

  const handlePageClick = (page) => {
    setCurrentPage(page);
  };

  const openModal = () => {
    setIsModalOpen(true);
    getsupportlist();
  };

  const closeModal = () => setIsModalOpen(false);

  const toggleAssign = (id) => {
    setSupportData((prev) =>
      prev.map((team) => ({
        ...team,
        assigned: team.id === id ? !team.assigned : false,
      }))
    );
  };

  const handleassign = async () => {
    const assignedTeam = supportData.find((team) => team.assigned);
    const assignedToId = assignedTeam?.id;
    const assignedToname = assignedTeam?.name;

    if (!assignedToId) {
      return toast.error("Please assign a support team member first.");
    }

    const formData = new FormData();
    formData.append("id", TicketNumber);
    formData.append("assignedto_id", assignedToId);
    formData.append("assignedby_id", userDetails?.id);

    try {
      setIsLoading(true);

      const response = await fetch(
        `${process.env.REACT_APP_BASEURL}/apis/assign.php`,
        {
          method: "POST",
          body: formData,
        }
      );

      const data = await response.json();
      if (response.ok) {
        getsupportlist();
        fetchTickets();
        closeModal();
        toast.success(`${selectedticketno} is assigned to ${assignedToname}`);
      } else {
        alert("An unexpected error occurred.");
      }
    } catch (error) {
      console.error("Error during ticket submission:", error);
      alert("Error occurred while assigning ticket.");
    } finally {
      setIsLoading(false);
    }
  };

  const getsupportlist = async () => {
    try {
      const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/supportlist.php`;
      const formData = new FormData();
      formData.append("subscribed", userDetails?.sub);

      const response = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();

      if (result?.data && Array.isArray(result.data)) {
        const updatedList = result.data.map((member) => ({
          ...member,
          assigned: member.id === assignedTo,
        }));

        setSupportData(updatedList);
      } else {
        console.error("Invalid response format from supportlist.php:", result);
        setSupportData([]);
      }
    } catch (error) {
      console.error("Error fetching support list:", error);
      setSupportData([]);
    }
  };

  useEffect(() => {
    const fetchSupportList = async () => {
      try {
        const data = await getsupportlist();
      } catch (error) {
        console.error("Error fetching support list:", error);
      }
    };

    fetchSupportList();
  }, []);

  return (
    <div className="taa">
      <button onClick={openModal} className="tab">
        ASSIGN
      </button>

      {isLoading && <Loading type="assign" />}

      {isModalOpen && (
        <div className="tac">
          <div className="tad">
            <div className="tae">
              <div className="tad-a">
                Ticket Number: <strong>{selectedticketno}</strong>
              </div>
              <button className="taf" onClick={closeModal}>
                <span className="tag">Close</span>
                <span className="tah">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                  >
                    <path d="M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z" />
                  </svg>
                </span>
              </button>
            </div>
            {Array.isArray(currentData) && currentData.length > 0 ? (
              <>
                <div className="tai">
                  <span>
                    <Marquee speed={40} direction={"left"}>
                      Support Team
                    </Marquee>
                  </span>
                </div>
                <div className="tan01">
                  <table className="tan">
                    <thead>
                      <tr>
                        <th>Sno</th>
                        <th>Name</th>
                        <th>Current Shift</th>
                        <th>Pending</th>
                        <th>Completed</th>
                        <th>Total</th>
                        <th>Assign</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentData.map((team, index) => (
                        <tr
                          key={index}
                          className={team.assigned ? "assigned-row" : ""}
                        >
                          <td>{index + 1}.</td>
                          <td>{team.name}</td>
                          <td>{team.current_shift}</td>
                          <td>{team.pending_tickets}</td>
                          <td>{team.completed_tickets}</td>
                          <td>{team.total_tickets}</td>
                          <td>
                            <button
                              className="taj"
                              disabled={team.assigned}
                              onClick={() => toggleAssign(team.id)}
                            >
                              {team.assigned ? "Assigned" : "Assign"}
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </>
            ) : (
              <div style={{ paddingTop: "50px" }}>
                {" "}
                No Teams Have Been Created Yet
              </div>
            )}

            {totalPages > 1 && (
              <div className="pagination-controls">
                <button onClick={handlePrevPage} disabled={currentPage === 1}>
                  Prev
                </button>
                {Array.from({ length: totalPages }, (_, i) => (
                  <button
                    key={i + 1}
                    className={currentPage === i + 1 ? "active-page" : ""}
                    onClick={() => handlePageClick(i + 1)}
                  >
                    {i + 1}
                  </button>
                ))}
                <button
                  onClick={handleNextPage}
                  disabled={currentPage === totalPages}
                >
                  Next
                </button>
              </div>
            )}

            {Array.isArray(supportData) > 0 && (
              <div className="tak">
                <button className="tal" type="submit" onClick={handleassign}>
                  Submit
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default Ticketassign;
